import { Body, Box, Icon } from './'

export const WhatsThis = ({ text, onClick, mobile, desktop, color = 'white' }) => (
  <Box
    alignItems="center"
    gap={4}
    cursor="pointer"
    onClick={onClick}
    className={`${mobile ? 'mobile-only' : ''}${desktop ? 'desktop-only' : ''}`}
  >
    <Icon icon="Help" fill={color} />
    <Body color={color} underline bold alt italic>{text}</Body>
  </Box>
)